// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ignore<T extends unknown[]>(..._: T) {
    // nothing to do
}
